import { articlesPart1 } from "./articles-part1";
import { articlesPart2 } from "./articles-part2";

export const articles = [...articlesPart1, ...articlesPart2];
